module.exports = __webpack_public_path__ + "img/3_73.9b8d7f6c.png";